var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-skeleton-loader',{staticClass:"full-height-image-skeleton-loader",attrs:{"type":"image","transition":"fade-transition"}})}
var staticRenderFns = []

export { render, staticRenderFns }